import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { combineLatest, Observable } from 'rxjs';
import { LoadDataFacade, SearchCriteria, SetInitialStateFacade } from '../../../../../../common/models';
import { HubLoanerPhoneListState, HubLoanerPhoneListStateModel } from './hub-loaner-phone-list-state';
import { HubLoanerPhoneListSearchCriteria } from '../../models/hub-loaner-phones.model';
import {
  HubLoanerPhoneListInitialState,
  HubLoanerPhoneListItemDelete,
  HubLoanerPhoneListItemReturn,
  HubLoanerPhoneListLoad,
} from './hub-loaner-phone-list.actions';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../../list-search-criteria';
import { MatDialogRef } from '@angular/material/dialog';
import { HubItemFacade } from '../hub-item.facade';
import { take } from 'rxjs/operators';
import { ConfirmationDialogAfterClosedModel } from '../../../../../../ui-kit';

@Injectable({ providedIn: 'root' })
export class HubLoanerPhoneListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<HubLoanerPhoneListStateModel> = this.store.select(HubLoanerPhoneListState.getState);
  loaded$: Observable<boolean> = this.store.select(HubLoanerPhoneListState.getLoaded);
  isDeleting$: Observable<boolean> = this.store.select(HubLoanerPhoneListState.isDeleting);

  constructor(
    private store: Store,
    private hubItemFacade: HubItemFacade,
    private listSearchCriteriaFacade: ListSearchCriteriaFacade,
  ) {}

  loadAll(): void {
    combineLatest([this.hubItemFacade.hubId$, this.getLoanerPhonesSearchCriteria()])
      .pipe(take(1))
      .subscribe(([hubId, searchCriteria]: [number, HubLoanerPhoneListSearchCriteria]) =>
        this.store.dispatch(new HubLoanerPhoneListLoad({ hubId, searchCriteria })),
      );
  }

  returnLoanerPhoneListItem(
    dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>,
    hubId: number,
    id: number,
    returnTimestamp: number,
  ): void {
    this.getLoanerPhonesSearchCriteria().subscribe((searchCriteria: HubLoanerPhoneListSearchCriteria) =>
      this.store.dispatch(
        new HubLoanerPhoneListItemReturn({
          dialog,
          hubId,
          id,
          returnTimestamp,
          searchCriteria,
        }),
      ),
    );
  }

  deleteLoanerPhoneListItem(dialog: MatDialogRef<ConfirmationDialogAfterClosedModel>, hubId: number, id: number): void {
    this.getLoanerPhonesSearchCriteria().subscribe((searchCriteria: HubLoanerPhoneListSearchCriteria) =>
      this.store.dispatch(
        new HubLoanerPhoneListItemDelete({
          dialog,
          hubId,
          id,
          searchCriteria,
        }),
      ),
    );
  }

  setInitialState(): void {
    this.store.dispatch(new HubLoanerPhoneListInitialState());
  }

  private getLoanerPhonesSearchCriteria(): Observable<SearchCriteria> {
    return this.listSearchCriteriaFacade.getSearchCriteriaByListType(ListSearchCriteriaType.LoanerPhones);
  }
}
